import React from 'react';
import "../layout/Panel.css";

const cx = require('classnames');

export default class extends React.Component {
    render() {
        const {title, options, label} = this.props;
        return (
            <div>
                <div className="page-header row no-gutters py-4">
                    <div className="col-12 col-sm-4 text-center text-sm-left mb-0">
                        <span className="text-uppercase page-subtitle"></span>
                        <h3 className="page-title">{title}</h3>
                    </div>

                </div>
                <div className="text-sm-right">
                    {options}
                </div>
                <div >
                    {React.cloneElement(this.props.children, { props: this.props })}
                </div>

                <footer className="main-footer d-flex p-2 px-3 bg-white border-top">
                    <ul className="nav">
                        <li className="nav-item">
                            <a className="nav-link" href="#"></a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link" href="#"></a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link" href="#"></a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link" href="#"></a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link" href="#"></a>
                        </li>
                    </ul>
                    <span className="copyright ml-auto my-auto mr-2">Copyright © {new Date().getFullYear()}
            </span>
                </footer>
            </div>
        )
    }
}
